import { tv } from "@/lib/tailwind-variants";

export const CONTENT_SCROLL_TYPE = {
  PAGE: "page", // メインコンテンツ全体がスクロール
  SECTION: "section", // メインコンテンツは100dvh、内部の各セクションがスクロール
} as const;

export const CONTENT_PADDING = {
  DEFAULT: "default", // 左右に px-6 の余白を設ける（既定）
  NONE: "none", // 余白なし（左右・上下とも端まで＝フルブリード。isExpand の py より優先）
} as const;

export const mainLayoutVariants = tv({
  slots: {
    main: "max-w-full",
  },
  variants: {
    isExpand: {
      true: {
        main: "pt-2 pb-6",
      },
      false: {
        main: "py-4",
      },
    },
    contentScrollType: {
      [CONTENT_SCROLL_TYPE.PAGE]: {
        main: "",
      },
      [CONTENT_SCROLL_TYPE.SECTION]: {
        main: "flex h-[calc(100dvh-var(--header-height))] flex-col",
      },
    },
    contentPadding: {
      [CONTENT_PADDING.DEFAULT]: {
        main: "px-6",
      },
      [CONTENT_PADDING.NONE]: {
        // 上下も 0 にしてヘッダ直下〜画面下端までフルブリード。
        // contentPadding は variants の最後に適用されるため、tailwind-merge で
        // ここの py-0 が isExpand の py-4 / pt-2 pb-6 に勝つ。
        main: "px-0 py-0",
      },
    },
  },
  defaultVariants: {
    isExpand: false,
    contentScrollType: CONTENT_SCROLL_TYPE.PAGE,
    contentPadding: CONTENT_PADDING.DEFAULT,
  },
});
